import {BenefitPriceBreakdown, PricingBreakdown} from './PricingBreakdown'

export type IndividualQuoteResponse = {
    lifeId: string
    totalPlanPrice: number
    pricesByBenefit: BenefitPriceBreakdown
    benefitPriceBreakdown: PricingBreakdown
}